import styled from "styled-components";
export const Styles = styled.div`
  #coursesSection .container {
    position: relative;
    text-align: center;
    margin-top: 140px;
  }
  #coursesSection .container .semi-column {
    position: absolute;
    left: 0;
    top: 30px;
    height: 200px;
  }
  #coursesSection .container .bg {
    position: absolute;
    top: 0%;
    right: -38%;
    height: 900px;
  }
  #coursesSection .container .tag {
    margin-top: 40px;
  }
  #coursesSection .section-title {
    margin-bottom: 80px;
  }
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .courses-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 60px;
  }
  @media (max-width: 1400px) {
    #coursesSection .container .bg {
      height: 90%;
    }
  }
  @media (max-width: 1200px) {
    #coursesSection .container .bg {
      height: 70%;
    }
  }
  @media (max-width: 992px) {
    #coursesSection .container .semi-column {
      height: 150px;
    }
    #coursesSection .container .bg {
      top: 80px;
      height: 70%;
    }
    #coursesSection .container .tag {
      margin-top: 100px;
    }
  }
  @media (max-width: 767px) {
    #coursesSection .container .semi-column {
      height: 150px;
    }
    #coursesSection .container .bg {
      top: 170px;
      height: 70%;
    }
    #coursesSection .container .tag {
      height: 100px;
      margin-top: 0;
    }
    .courses-container {
      flex-direction: column;
      gap: 0px;
    }
  }
`;
